import { render, staticRenderFns } from "./BranchDrawer.vue?vue&type=template&id=122786b5&scoped=true"
import script from "./BranchDrawer.vue?vue&type=script&lang=js"
export * from "./BranchDrawer.vue?vue&type=script&lang=js"
import style0 from "./BranchDrawer.vue?vue&type=style&index=0&id=122786b5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "122786b5",
  null
  
)

export default component.exports